import type { BankAccount } from "@/schemas";
import { BankAccountResponseSchema } from "@/schemas";

import { apiRequest } from "./apiUtils";

export async function getBankAccount() {
  const data = await apiRequest<unknown>(`user/profile/bank-account`, {
    method: "GET",
  });
  return BankAccountResponseSchema.parse(data);
}

export async function updateBankAccount(bankAccount: BankAccount) {
  const data = await apiRequest<unknown>(`user/profile/bank-account`, {
    method: "PATCH",
    body: JSON.stringify(bankAccount),
  });
  return BankAccountResponseSchema.parse(data);
}
